<template>
  <GlobalFooter class="i-copyright" :links="links" :copyright="copyright" />
</template>
<script>
import moment from "moment";

export default {
  name: "i-copyright",
  data() {
    return {
      year: "11",
      links: [
        {
          title: "返回首页",
          key: "index",
          href: "/",
          blankTarget: true,
        },
        // {
        //   title: "区块浏览器",
        //   key: "explorer",
        //   href: "",
        //   blankTarget: true,
        // },
        {
          title: "帮助中心",
          key: "help",
          href: "javascript:;",
          blankTarget: false,
        },
      ],
      copyright: `Copyright © ${this.year} 数金公服 · 长数链 - 链接金融科技，赋能产业升级`,
    };
  },
  beforeCreate() {
    this.year = moment().format("YYYY"); // 获取当前年份
  },
};
</script>
<style lang="less">
.i-copyright {
  flex: 0 0 auto;
  &-hidden {
    display: none;
  }
}
</style>
